// BbsInfoDict.js
import IsValid from "../../value/IsValid";
import { InputType, TableColumnType } from "../../value/AppConst";

const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    custId : {toAdd: true, toEdit: true},
    
    bbsTypeCd : {
        id: 'bbsTypeCd', required: true, toAdd: true, toEdit: true,
    },
    bbsInfoSeq : {
        id: 'bbsInfoSeq', required: true, toAdd: false, toEdit: true,
    },
    dcCd : {
        id: 'dcCd', required: false, toAdd: true, toEdit: true,
    },
    /* writer : {
        id: 'writer', label: 'writer label', type: 'text', required: false,
        toAdd: true, toEdit: true,
        errorHelp: '15자 이내로 입력하세요.',
        check: (value) => {return ValueUtil.isNullString(value) || ValueUtil.textInRange(value,1,15)},
    }, */
    email : {
        id: 'email', label: 'E-mail', type: InputType.email, required: false,
        toAdd: true, toEdit: true,
        min:0, max:60,
        errorHelp: '60자 이내로 입력하세요.',
        check: (value) => IsValid.emailNullable(value, 60),
    },
    title : {
        id: 'title', label: '제목', type: InputType.text, required: true,
        toAdd: true, toEdit: true,
        errorHelp: '70자 이내로 입력하세요.',
        min: 1, max: 200,
        check: (value) => IsValid.string(value, 1, 200),
    },
    content : {
        id: 'content', label: '내용', type: InputType.text, required: true,
        toAdd: true, toEdit: true,
        errorHelp: '1200자 이내로 입력하세요.',
        min: 5, max: 3000,
        rows: 8,
        inputPropsStyle: {fontSize:'0.9rem'},
        check: (value) => IsValid.string(value, 5, 3000),
    },
    forAll : {
        id: 'forAll', label: '물류센터 전체', type: InputType.checkbox, required: true,
        toAdd: true, toEdit: true,
        default: true,
    },
    popup : {
        id: 'popup', label: '팝업창 표시', type: InputType.checkbox, required: true,
        toAdd: true, toEdit: true,
        default: false,
    },
    popupStartAt : {
        id: 'popupStartAt', label: '팝업시작시각', type: InputType.datetime, required: false,
        toAdd: true, toEdit: true,
        check: (value) => IsValid.datetimeNullable(value),
    },
    popupEndAt : {
        id: 'popupEndAt', label: '팝업종료시각', type: InputType.datetime, required: false,
        toAdd: true, toEdit: true,
        check: (value) => IsValid.datetimeNullable(value),
    },
    topOrder : {
        id: 'topOrder', label: '맨 위에 표시', type: InputType.checkbox, required: true,
        toAdd: true, toEdit: true,
        default: false,
    },
    announceDate : {
        id: 'announceDate', label: '공지날짜', type: InputType.date, required: true,
        toAdd: true, toEdit: true,
    }
    /* boldTitle : {
        id: 'boldTitle', label: 'boldTitle label', type: 'text', required: false,
        toAdd: true, toEdit: true,
        errorHelp: '3자 이내로 입력하세요.',
        check: (value) => {return ValueUtil.isNullString(value) || ValueUtil.textInRange(value,1,3)},
    },
    titleColor : {
        id: 'titleColor', label: 'titleColor label', type: 'text', required: false,
        toAdd: true, toEdit: true,
        errorHelp: '3자 이내로 입력하세요.',
        check: (value) => {return ValueUtil.isNullString(value) || ValueUtil.textInRange(value,1,3)},
    },
    serverUrl : {
        id: 'serverUrl', label: 'serverUrl label', type: 'text', required: false,
        toAdd: true, toEdit: true,
        errorHelp: '50자 이내로 입력하세요.',
        check: (value) => {return ValueUtil.isNullString(value) || ValueUtil.textInRange(value,1,50)},
    },
    fileAddr : {
        id: 'fileAddr', label: 'fileAddr label', type: 'text', required: false,
        toAdd: true, toEdit: true,
    },
    fileName1 : {
        id: 'fileName1', label: 'File 1', type: 'text', required: false,
        toAdd: true, toEdit: true,
    },
    fileName2 : {
        id: 'fileName2', label: 'File 2', type: 'text', required: false,
        toAdd: true, toEdit: true,
    },
    fileName3 : {
        id: 'fileName3', label: 'File 3', type: 'text', required: false,
        toAdd: true, toEdit: true,
    },
    fileName4 : {
        id: 'fileName4', label: 'File 4', type: 'text', required: false,
        toAdd: true, toEdit: true,
    },
    fileName5 : {
        id: 'fileName5', label: 'File 5', type: 'text', required: false,
        toAdd: true, toEdit: true,
    }, */
};

function printFileName(row) {
    // check how many files are attached
    const fileNames = [];
    for(let i=1; i<=5; i++) {
        const key = 'fileName' + i;
        if(row[key]) fileNames.push(row[key]);
    }
    // return first name and count-1 (xxx 외 n개)
    if(fileNames.length === 0) return '';
    else return fileNames[0] + (fileNames.length > 1 ? ' 외 ' + (fileNames.length-1) + '개' : '');
}

function printTitle(row) {
    return row.boldTitle ? <b>{row.title}</b> : <span>{row.title}</span>;
}

export const BbsInfoDict = {
    inputMap: Dict,
    bbcType: {
        Announce: {code:'01', label:'공지사항'},
        VehAlloc: {code:'02', label:'배차현황'},
        Update: {code:'03', label:'업데이트'},
    },
    errorTitle: {
        Add: '공지사항 생성 오류',
        Edit: '공지사항 수정 오류',
        Remove: '공지사항 삭제 오류',
        Get: '공지사항 조회 오류',
    },
    tableProps: {
        tableId: 'bbsInfoTable',
        uniqueKey: 'bbsInfoSeq',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            growToFill: true,
        },
        columns: [
            { id: 'dcName', label: '소속센터', width: 70, show: true, option:{align: 'center', type: TableColumnType.TEXT} },
            { id: 'title', label: '제목', width: 400, show: true, option:{align: 'inherit', print: (r,i,v) => {return printTitle(r)}} },
            { id: 'readCnt', label: '조회수', width: 50, show: true, option:{align: 'right', type: TableColumnType.INTEGER} },
            { id: 'file', label: '첨부파일', width: 150, show: true, option:{align: 'inherit', print: (r,i,v) => {return printFileName(r)}} },
            { id: 'writer', label: '등록자', width: 100, show: true, option:{align: 'center', type: TableColumnType.TEXT} },
            { id: 'updatedDate', label: '최종수정', width: 120, show: true, option:{align: 'inherit', type: TableColumnType.DATETIME} },
            // { id: 'email', label: Dict.email.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
            // { id: 'content', label: Dict.content.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
            //{ id: 'forAll', label: Dict.forAll.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
            //{ id: 'popup', label: Dict.popup.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
            //{ id: 'popupStartAt', label: Dict.popupStartAt.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.DATE} },
            //{ id: 'popupEndAt', label: Dict.popupEndAt.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.DATE} },
            //{ id: 'popupDays', label: Dict.popupDays.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.INTEGER} },
            //{ id: 'topOrder', label: Dict.topOrder.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
            //{ id: 'boldTitle', label: Dict.boldTitle.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
            //{ id: 'titleColor', label: Dict.titleColor.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
            //{ id: 'serverUrl', label: Dict.serverUrl.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
            //{ id: 'fileName1', label: Dict.fileName1.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
            //{ id: 'fileName2', label: Dict.fileName2.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
            //{ id: 'fileName3', label: Dict.fileName3.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
            //{ id: 'fileName4', label: Dict.fileName4.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
            //{ id: 'fileName5', label: Dict.fileName5.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
            //{ id: 'regUser', label: Dict.regUser.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
            //{ id: 'regDate', label: Dict.regDate.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.DATETIME} },
            //{ id: 'updatedUser', label: Dict.updatedUser.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} }
        ]
    },
};